import React from "react";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { withStyles } from "@mui/styles";
import { Box, Button, Typography } from "@mui/material";
import { useStyles } from "./indexStyles";

function CustomDialog(props) {
  const {
    classes: {},
    buttonText = "Proceed",
    subtitle = null,
    text = null,
    handleOnClose,
    modal,
    modalKey,
    title = null,
  } = props;

  return (
    <Dialog
      onClose={(event, reason) => handleOnClose(event, reason, modalKey)}
      aria-labelledby="simple-dialog-title"
      open={modal[modalKey]}
    >
      {title && <DialogTitle id="simple-dialog-title">{title}</DialogTitle>}

      <DialogContent>
        <Box mt={2} mb={2}>
          {subtitle && (
            <Box mb={3}>
              <Typography variant="subtitle1">{subtitle}</Typography>
            </Box>
          )}
          {text && (
            <Box>
              <Typography variant="caption">{text}</Typography>
            </Box>
          )}
        </Box>
      </DialogContent>

      <Box m={0.5} mt={0} display={"flex"} justifyContent={"center"}>
        <Button
          type={"button"}
          variant="contained"
          size="small"
          color="primary"
          onClick={(event, reason) => handleOnClose(event, reason, modalKey)}
          fullWidth
        >
          {buttonText}
        </Button>
      </Box>
    </Dialog>
  );
}

export default withStyles(useStyles, { withTheme: true })(CustomDialog);
